import {CompoundMappingType, CompoundOrderStatus} from '@cypro/engine/database/schema'
import {getDatetimeFormatter} from '@cypro/ui/utils'
import * as z from 'zod'

export const MAPPING_TYPE_KEYS: Record<CompoundMappingType, string> = {
  [CompoundMappingType.enum.DRUG]: 'mapping_type_drug',
  [CompoundMappingType.enum.CARRIER]: 'mapping_type_carrier',
  [CompoundMappingType.enum.PATIENT_CONTAINER]: 'mapping_type_patient_container',
  [CompoundMappingType.enum.IV_SET]: 'mapping_type_iv_set',
}

// String form of the machine carrier type (0-3) used by the select fields. The engine's
// CompoundCarrierType is an int schema for payloads; selects bind string values.
export const CARRIER_TYPE_VALUES = z.enum(['0', '1', '2', '3'])

export const CARRIER_TYPE_KEYS: Record<number, string> = {
  0: 'carrier_type_none',
  1: 'carrier_type_nacl',
  2: 'carrier_type_glucose_5',
  3: 'carrier_type_glucose_10',
}

export const ORDER_STATUS_COLORS: Record<CompoundOrderStatus, string> = {
  [CompoundOrderStatus.enum.PENDING]: 'yellow',
  [CompoundOrderStatus.enum.SENT]: 'blue',
  [CompoundOrderStatus.enum.RESULT_RECEIVED]: 'green',
  [CompoundOrderStatus.enum.FAILED]: 'red',
  [CompoundOrderStatus.enum.VOID]: 'gray',
}

export const RELEASE_STATUS_KEYS: Record<number, string> = {
  0: 'release_status_unknown',
  1: 'release_status_invalid',
  2: 'release_status_released',
  3: 'release_status_invalid_copied',
}

export function orderStatusColor(status: CompoundOrderStatus | null | undefined): string {
  return (status && ORDER_STATUS_COLORS[status]) || 'gray'
}

export function formatDate(value: string | number | Date | null | undefined): string {
  if (!value) return '-'
  const date = typeof value === 'string' || typeof value === 'number' ? new Date(value) : value
  return getDatetimeFormatter().format(date)
}
